import { createContext, useContext } from "react";

const noopRevealInMainView = () => false;

export const MainViewScrollContext = createContext({
  revealInMainView: noopRevealInMainView,
  scrollRef: null,
});

export function useMainViewScroll() {
  return useContext(MainViewScrollContext);
}
